import { ChangeDetectionStrategy, Component, computed, input, model, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FormValueControl } from "@angular/forms/signals";

@Component({
    standalone: true,
    selector: "s25-ng-select",
    template: `
        @if (readonly()) {
            {{ selectedOption()?.label ?? "None" }}
        } @else {
            <select
                class="cn-form__control"
                [(ngModel)]="value"
                [attr.aria-label]="ariaLabel()"
                [disabled]="disabled()"
            >
                @for (option of options(); track option.value) {
                    <option [ngValue]="option.value">{{ option.label }}</option>
                }
            </select>
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule],
})
export class S25SelectComponent<T> implements FormValueControl<T | null> {
    readonly value = model<T | null>(null);
    readonly options = input.required<{ value: T; label: string }[]>();
    readonly ariaLabel = input<string>();
    readonly disabled = input<boolean>(false);
    readonly readonly = input<boolean>(false);

    readonly selectedOption = computed(() => {
        return this.options().find((item) => item.value === this.value());
    });
}
